/**
 * Standalone "Edit matching" modal for the gated segment editor (PLT-5707).
 * The Matching tab was carved out of the main product edit dialog into its own
 * team-only modal, launched from the row kebab. Wraps the shared
 * `MatchingSection` with a Save / Cancel footer, mirroring the edit dialog's
 * chrome so the two feel consistent.
 */
import { Dialog, Button } from '@primer/react';
import { useState } from 'react';
import styled from 'styled-components';
import { PiuProductState } from '@upright/common/model/input/companies/products/product-input-ui/types';
import { MatchingSection } from './matching-section';

interface Props {
  product: PiuProductState;
  onClose: () => void;
  onSave: (product: PiuProductState) => void;
}

export function MatchingEditDialog({ product, onClose, onSave }: Props) {
  const [editedProduct, setEditedProduct] = useState<PiuProductState>(product);

  return (
    <Dialog returnFocusRef={{ current: null }} onClose={onClose} title="Edit matching">
      <Dialog.Body sx={{ paddingTop: '0px', paddingBottom: '25px', paddingLeft: '0px', paddingRight: '0px' }}>
        <Main>
          <MatchingSection
            product={editedProduct}
            onProductUpdate={updatedProduct => {
              setEditedProduct(prev => ({ ...prev, ...updatedProduct }));
            }}
          />
        </Main>
      </Dialog.Body>
      <Dialog.Footer style={customFooterStyle}>
        <FooterContainer>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              onSave(editedProduct);
            }}
          >
            Save
          </Button>
        </FooterContainer>
      </Dialog.Footer>
    </Dialog>
  );
}

// Matches the footer spacing fix in the main product edit dialog.
const customFooterStyle = { marginLeft: '-16px', marginRight: '-16px', marginBottom: '-16px' };

const Main = styled.div`
  margin-top: var(--space__lg);
`;

const FooterContainer = styled.div`
  display: flex;
  gap: var(--space__sm);
  align-items: center;
`;
